// The puzzles interface, provided by `review-puzzles`: what another plugin
// needs to offer a puzzle for one of the reader's moves without importing
// the puzzles plugin. A puzzle is identified by the 1-based ply of the
// reader's move it is about; the position it starts from is the one before.

export const PUZZLES_API = 'puzzles';
export const PUZZLES_API_VERSION = '1.1.0';

/** The reader's record on one move's puzzle; `solving` while it is on the board. */
export type PuzzleStatus = 'solving' | 'solved' | 'failed';

/** The puzzle on the board, while one is: the 1-based ply of the reader's move it is about. */
export interface PuzzleRun {
  ply: number;
}

export interface Puzzles {
  /**
   * Set up the puzzle for the reader's move at a 1-based ply of the open
   * game: the stored puzzle when the finder kept one, else one made on
   * demand, so every judged move can be practised. Does nothing when the
   * game is not scanned or the move is not the reader's.
   */
  startForMove(ply: number): void;
  /** The record for the puzzle of the move at a 1-based ply, if it has one. */
  statusOf(ply: number): PuzzleStatus | undefined;
  /**
   * The puzzle on the board, from its start until "Back to the game", solved
   * or not; undefined while none is. While one is, the review's header is the
   * puzzle's banner (`review.header.puzzle`), not the game bar.
   */
  current(): PuzzleRun | undefined;
  /** Called whenever any status may have changed. Returns the unsubscribe. */
  subscribe(listener: () => void): () => void;
}
